/**
 * Optimistic cache of the signed-in user's "TOTP enrolled?" status, so the
 * account MFA pill can render the real ON/OFF instantly on repeat opens instead
 * of flashing a neutral loading state while `mfa.listFactors()` round-trips. The
 * value is always reconciled against the server on mount — this is a UI hint
 * only, keyed by user id so a different account on the same browser can't read a
 * stale status. Not sensitive (it's the user's own on/off flag, no secret).
 */
const LS_KEY = 'crewvex.mfaEnrolled';

export function getCachedMfa(userId) {
  if (!userId) return null;
  try {
    const o = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    return o && o.u === userId ? Boolean(o.e) : null;
  } catch (_) {
    return null;
  }
}

export function setCachedMfa(userId, enabled) {
  if (!userId) return;
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({ u: userId, e: Boolean(enabled) }));
  } catch (_) {
    /* ignore quota / private mode */
  }
}

/** Drop the cached MFA hint (called on sign-out — shared-device hygiene). */
export function clearCachedMfa() {
  try {
    localStorage.removeItem(LS_KEY);
  } catch (_) {
    /* ignore */
  }
}
